import {DownloadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Divider, Dropdown, Input, Menu, message, Modal, Row, Space, Table, Tooltip, Form, Upload, Select,  Spin} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../../Images/FilterIcon.svg';
import logo from '../../../Images/alux-logo.png';
import dayjs from 'dayjs';
import {fetchSalesOrderById} from '../../../slices/sales-order';
import moment from 'moment';
//import PrintWorkOrder3 from '../../Authentication/PrintWorkOrder3';
import html2pdf from 'html2pdf.js';
import { LoadingOutlined } from '@ant-design/icons';

const ViewSalesOrder = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const navigate = useNavigate();
  const [salesOrderData, setSalesOrderData] = useState(null);
    const [checkedList, setCheckedList] = useState([
    'SrNo',
    'section_no',
    'length',
    'pieces',
    'quantity',
    'alloy_detail',
    'temper_detail',
    'surface_finish_detail'
  ]);

  const printRef = useRef();
  const [modalTitle, setModalTitle] = useState('');
  const [popupData, setPopupData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  function getFileExtension(url) {
    return url.split('.').pop().split(/\#|\?/)[0];
  }

  const showModal = async (data, title) => {
    let extension = getFileExtension(data);
    const isPdf = extension === 'pdf';
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
      extension,
    );
    if (isImage) {
      setModalTitle(title);
      setPopupData(data);
      setIsModalVisible(true);
    } else if (isPdf) {
      window.open(data, '_blank', 'noopener,noreferrer');
    } else {
      const response = await fetch(data);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blobData = await response.blob();
      var blob = new Blob([blobData], { type: 'application/pdf' });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  };

  const loadImageAsBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const cacheBustUrl = `${url}${url.includes('?') ? '&' : '?'}nocache=${new Date().getTime()}`;

      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = cacheBustUrl;
    });
  };

  const handleDownloadPDF = () => {
    const element = printRef.current;
    if (!element) return;

    setLoadingPDF(true);
    const clone = element.cloneNode(true);
    clone.querySelectorAll('.no-print').forEach(el => el.remove());
    const logo = clone.querySelector('img.company-logo');
    if (logo) {
      const logoWrapper = document.createElement('div');
      logoWrapper.style.backgroundColor = 'white';
      logoWrapper.style.display = 'inline-block';
      logoWrapper.style.padding = '6px';
      logoWrapper.style.borderRadius = '4px';
      logoWrapper.style.textAlign = 'center';

      logo.parentNode.insertBefore(logoWrapper, logo);
      logoWrapper.appendChild(logo);
    }
    const imageElements = Array.from(clone.querySelectorAll('img')).filter(img => {
      const src = img.getAttribute('src') || '';
      return !img.classList.contains('company-logo') && !src.includes('logo.png');
    });

    const style = document.createElement('style');
    style.innerHTML = `
    * {
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #000000 !important;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
      }
      @page {
        size: A4 portrait;
        margin: 10mm !important;
      }
      body {
        font-size: 9px !important;
        margin: 0 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      .print-container-workorder {
        width: 794px !important;
        min-height: 1000px !important;
        position: relative !important;
        padding-bottom: 100px !important;
        margin: 0 auto !important;
      }
      .main-heading {
        font-size: 15px !important;
        text-align: center !important;
        width: 100% !important;
      }
      .page {
        page-break-after: always !important;
        position: relative !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .header-text {
        font-size: 10px !important;
        line-height: 1.2 !important;
        text-align: left !important;
      }
      .page-content {
        width: 100% !important;
        overflow: visible !important;
        font-size: 10px !important;
      }
      .signature-section {
        position: absolute !important;
        bottom: 10px !important;
        width: 100% !important;
        text-align: center !important;
        margin-top: 0 !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      .ant-row {
        display: flex !important;
        flex-wrap: wrap !important;
        margin-bottom: 5px !important;
      }
      .ant-col {
        box-sizing: border-box !important;
        padding: 1px !important;
      }
      h1, h2, h3, h4, h5 {
        color: rgb(2, 15, 28) !important;
        font-size: 12px !important;
        margin-bottom: 3px !important;
        margin-top: 0 !important;
      }
      .ant-table {
        width: 794px !important;
        font-size: 9px !important;
        table-layout: fixed !important;
        margin: 5px 0 !important;
        border-collapse: collapse !important;
      }
      .ant-table-container {
        overflow: visible !important;
        border: 1px solid #dee2e6 !important;
        padding: 0px !important;
        width: 794px !important;
      }
      .ant-table-wrapper {
        padding: 0 !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 2px 2px !important;
        font-size: 8px !important;
        background-color: white !important;
        border: 1px solid #dee2e6 !important;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        word-break: break-word !important;
        line-height: 1.1 !important;
        height: auto !important;
        min-height: 18px !important;
      }
      .ant-table-thead > tr > th {
        background: #fff !important;
        padding: 2px !important;
        font-weight: bold !important;
      }
      .ant-table-wrapper .ant-table-summary > tr > td {
        border: 1px solid #dee2e6 !important;
        padding: 1px 1px !important;
        font-size: 8px !important;
      }
      .summary-cell-center {
        text-align: center !important;
      }
      .summary-cell-right {
        text-align: right !important;
        padding-right: 3px !important;
      }
      .ant-divider {
        margin: 5px 0 !important;
        border-top: 1px solid #d9d9d9 !important;
      }
      .no-print {
        display: none !important;
      }
      .info-section {
        display: flex;
        justify-content: space-between;
        margin: 20px 0 !important;
        font-size: 12px !important;
      }
      .info-left {
        flex: 1;
        max-width: 60%;
      }
      .info-right {
        flex: 1;
        text-align: right;
        max-width: 35%;
      }
      .info-table {
        border-collapse: collapse;
        width: 100%;
        font-size: 12px;
      }
      .info-table td {
        vertical-align: top;
        padding: 2px 0;
      }
      .info-label {
        font-weight: bold;
      }
      .main-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px !important;
        margin-bottom: 20px;
      }
      .main-table th,
      .main-table td {
        border: 1px solid #dee2e6;
        padding: 6px 4px;
        text-align: center;
        vertical-align: middle;
        font-size: 12px;
      }
      .main-table th {
        background: transparent;
        color: black;
        font-weight: bold;
        font-size: 12px;
      }
      .main-table .section-image {
        width: 60px;
        height: 60px;
        object-fit: contain;
      }
      .total-row {
        font-weight: bold;
      }
      .signature-section {
        display: flex;
        justify-content: space-between;
        margin: 40px 0 20px;
        gap: 60px;
      }
      .signature-box {
        text-align: center;
        font-weight: bold;
        font-size: 12px;
      }
      .logo-section img {
        max-width: 150px !important;
        height: auto !important;
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
      }
      .copy-label {
        float: right;
        font-size: 14px;
        font-weight: normal;
      }
      .new-info {
        margin-top: 20px !important;
      }`;
    clone.appendChild(style);
    const base64ConversionPromises = imageElements.map(img => {
      const src = img.getAttribute('src');
      if (!src || src.startsWith('data:') || img.classList.contains('company-logo')) {
        return Promise.resolve();
      }

      return loadImageAsBase64(src)
        .then(base64 => {
          img.setAttribute('src', base64);
        })
        .catch(err => {
          console.warn('Failed to load base64 image:', src, err);
        });
    });
    const logoImage = clone.querySelector('img.company-logo');
    if (logoImage && !logoImage.src.startsWith('data:')) {
      base64ConversionPromises.push(
        loadImageAsBase64(logoImage.src)
          .then(base64 => {
            logoImage.setAttribute('src', base64);
          })
          .catch(err => {
            console.warn('Failed to load base64 logo:', logoImage.src, err);
          })
      );
    }
    Promise.all(base64ConversionPromises)
      .then(() => {
        setTimeout(() => {
          const opt = {
            margin: 0,
            filename: `SalesOrder_${salesOrderData?.sales_order_no || 'N/A'}.pdf`,
            image: { type: 'png', quality: 1 },
            html2canvas: {
              scale: 2,
              useCORS: true,
              allowTaint: true,
              logging: true,
              imageTimeout: 15000,
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          };

          html2pdf().set(opt).from(clone).save()
            .then(() => setLoadingPDF(false))
            .catch(err => {
              console.error("PDF generation error:", err);
              setLoadingPDF(false);
            });
        }, 500);
      })
      .catch(err => {
        console.error("Error converting images to base64:", err);
        setLoadingPDF(false);
      });
  };

  const fetchData = async () => {
    try {
      const response = await dispatch(
        fetchSalesOrderById(id),
      ).unwrap();

      setSalesOrderData(response.data);
    } catch (error) {
      console.error('Failed to fetch quotation:', error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setPopupData(null);
    setModalTitle('');
  };

  const columns = [
    {
      title: 'Sr.No',
      dataIndex: 'SrNo',
      render: (text, record, index) => index + 1,
      align: 'center',
    },
    {
      title: 'Section Number',
      dataIndex: 'section_no',
      align: 'center',
      key: 'section_no',
      render: (text, record) => {
        return <span>{record?.section_no || 'N/A'}</span>;
      },
    },
    {
      title: 'Length(mm)',
      dataIndex: 'length',
      key: 'length',
      align: 'center',
      render: length => {
        return <span>{length || 'N/A'}</span>;
      },
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      align: 'center',
      render: pieces => {
        return <span>{pieces || 'N/A'}</span>;
      },
    },
    {
      title: 'Quantity (kg)',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
       render: (text, record) => {
        return <span>{record?.quantity || 'N/A'}</span>;
      }
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy_detail',
      key: 'alloy_detail',
      render: (_, record) => {
        const alloyName = record?.alloy_detail?.name || 'N/A';
        const alloyCode = record?.alloy_detail?.color_code || 'N/A';
        return (
          <span>
            {alloyName} ({alloyCode})
          </span>
        );
      }
    },
    {
      title: 'Temper',
      dataIndex: 'temper_detail',
      key: 'temper_detail',
      align: 'center',
      render: (_, record) => {
        const temperName = record?.temper_detail?.name || 'N/A';
        const temperCode = record?.temper_detail?.code || 'N/A';

        return (
          <span>
            {temperName} ({temperCode})
          </span>
        );
      },
    },
    {
      title: 'Surface Finish',
      dataIndex: 'surface_finish_detail',
      key: 'surface_finish_detail',
      align: 'center',
      render: (surface_finish_detail) => {
        if (surface_finish_detail && surface_finish_detail.length > 0) {
          return surface_finish_detail.map(item => item.name).join(', ');
        }
        return 'N/A';
      },
    },
  ];

  const dynamicColumns = columns.filter(column =>
    checkedList.includes(column.dataIndex || column.key),
  );

  return (
    <>
     
      {loadingPDF && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined style={{ fontSize: 48, color: '#12406a' }} spin />
            }
            tip="Generating PDF..."
          />
        </div>
      )}
      <div>
        <div style={{position: 'sticky', zIndex: '1000', background: '#fff', padding: '16px', top: '0'}}>
          <Row
            className="pagenamerow mb-0"
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>View Sales Order</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/sales-order-list">Sales Orders</Link> },
                    { title: 'View Sales Order' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              {/* {currentUser.permissions.permissions.workorder.includes(
                'change_workorder',
              ) && (
                  <>
                    <Tooltip placement="top" title={'Download PDF'}>
                      <Button
                        type="primary"
                        icon={loadingPDF ? <LoadingOutlined /> : <DownloadOutlined />}
                        style={{ marginBottom: '20px', float: 'right' }}
                        onClick={handleDownloadPDF}
                        loading={loadingPDF}
                      >
                        {loadingPDF ? 'Generating PDF...' : 'Download PDF'}
                      </Button>
                    </Tooltip>
                  </>
                )} */}
                {currentUser.permissions.permissions.inquiry_salesorder.includes('change_inquirysalesorder') && (
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      style={{
                        marginBottom: '20px',
                        float: 'center',
                        marginRight: '10px',
                      }}
                      onClick={() =>
                        navigate(`/create-sales-order-work-order/${salesOrderData?.id}`)
                      }
                    >
                      Convert To Work Order
                    </Button>
                )}
              {/* {currentUser.permissions.permissions.workorder.includes(
                'change_workorder',
              ) && (
                  <Button
                    type="primary"
                    onClick={() =>
                      navigate(`/edit-sales-order/${salesOrderData?.id}`)
                    }
                    style={{
                      marginBottom: '20px',
                      float: 'center',
                      marginRight: '10px',
                    }}
                    icon={<EditOutlined />}
                  >
                    Edit Sales Order
                  </Button>
                )} */}
             
            </Col>
          </Row>
        </div>
        <div className="formwrapper">
          <Row gutter={[16, 16]} className="viewform">
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Order Number</label>
              <div className="customvalue">
                <div className="customvalue">
                  {salesOrderData?.sales_order_no || 'N/A'}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Order Date</label>
              <div className="customvalue">
                {salesOrderData?.order_date
                  ? dayjs(salesOrderData.order_date).format('DD/MM/YYYY')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">P.O. No.</label>
              <div className="customvalue">
                {salesOrderData?.purchase_order_number || 'N/A'}
              </div>
            </Col>
             <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">P.O. Date</label>
              <div className="customvalue">
                {dayjs(salesOrderData?.purchase_order_date).format(
                  'DD/MM/YYYY',
                ) || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Customer</label>
              <div className="customvalue">
                {salesOrderData?.customer_name || 'N/A'}
              </div>
            </Col>
            
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Mode Of Packing</label>
              <div className="customvalue">
                {salesOrderData?.packing_mode_detail?.length
                  ? salesOrderData.packing_mode_detail.map(item => item.name).join(', ')
                  : 'N/A'}
              </div>
            </Col>
      
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Status</label>
              <div className="customvalue">
                {salesOrderData?.status || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Remarks</label>
              <div className="customvalue">
                {salesOrderData?.remarks || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label
                htmlFor="viewFileButton"
                style={{ display: 'block', marginBottom: '8px' }}
              >
                Purchase Order Copy:
              </label>
              {salesOrderData?.purchase_order_copy !== null ? (
                <Button
                  type="secondry"
                  onClick={() =>
                    showModal(salesOrderData?.purchase_order_copy, 'Purchase Order Copy')
                  }
                >
                  View File
                </Button>
              ) : (
                <div className="customvalue">N/A</div>
              )}
            </Col>

            
          </Row>

          <Divider />

          <div className="flex justify-between gridtitle mt-10" >
            <h3>Sales Order Items List</h3>
           
          </div>
           <Table
            dataSource={salesOrderData?.inquiry_salesorder_details}
            columns={dynamicColumns}
            pagination={false}
          />
         
        </div>{' '}
      </div>

      {/* Existing Modal */}
      <Modal
        title={modalTitle}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {popupData ? (
          <img src={popupData} alt="" style={{ width: '100%', height: 'auto' }} />
        ) : (
          <p>No diagram available.</p>
        )}
      </Modal>
    </>
  );
};

export default ViewSalesOrder;
